// import { toast } from "react-toastify";
import useLabels from "../../hooks/useLabels";
import { MultipleSelect, Select } from "../FormComponents";
import { CTA } from "../Generic";

const FooterCell = ({ table, type = null }) => {
  const [getLabel] = useLabels();
  const meta = table.options.meta;
  // const data = table.options.data;
  const selectedRows = table.getSelectedRowModel().rows;

  const removeRows = () => {
    meta.removeSelectedRows(
      table.getSelectedRowModel().rows.map((row) => row.index)
    );
    table.resetRowSelection();
  };

  const customIdInvalidColor = "custom-id-invalid-color";
  const customIdInvalidState = "custom-id-invalid-state";

  const onChange = (newRow) => {
    
    // if (meta?.type === 'newAnalysisProtocol') {
    //   // checks on new analysis protocol creation
    //   const sameSubstance = (newRow?.colors || [])?.length > 0 ? (data?.find((d) => d?.substance_name === newRow?.substance_name) || null) : null;
    //   let sameSubstanceDiffColor = false;
    //   if (sameSubstance !== null && sameSubstance?.colors?.length > 0) {
    //     sameSubstance?.colors?.forEach(color => {
    //       if (!newRow?.colors?.includes(color)) {
    //         sameSubstanceDiffColor = true;
    //       return false;
    //     }
    //     });
    //   }
    //   if (!sameSubstanceDiffColor) {
    //     const allColors = new Set();
    //     data?.reduce((_, s) => allColors.add(s?.colors), null);
    //     const allColorsArray = Array.from(allColors);
    //     let sameSubstanceDiffColor = false;
    //     if (allColorsArray?.length > 0 && newRow?.colors?.length > 0) {
    //       if (newRow?.colors?.every(item => !allColorsArray.includes(item)) && newRow?.colors?.length === 1) {
    //         sameSubstanceDiffColor = true;
    //       }
    //     }
    //   }
    // }

    //   console.log(data, sameSubstance, newRow?.colors)
    //   console.log('-----------------------')
    //   const allStates = new Set();
    //   data?.reduce((_, s) => allStates.add(s?.states), null);
    //   const allStatesArray = Array.from(allStates);
    //   let diffState = false;
    //   if (allStatesArray?.length > 0 && newRow?.states?.length > 0) {
    //     if (newRow?.states?.every(item => !allStatesArray.includes(item)) && newRow?.states?.length === 1) {
    //       diffState = true;
    //     }
    //   }

    //   if (sameSubstanceDiffColor || diffState) {
    //     const name = getLabel('substance_' + newRow?.substance_name);
    //     const msg = sameSubstanceDiffColor ? getLabel("toast_analysisProtocolInvalidColor", { name: name }) :
    //     getLabel("toast_analysisProtocolInvalidState", { name: name })
    //     toast.warning(msg, {
    //       toastId: sameSubstanceDiffColor ? customIdInvalidColor : customIdInvalidState,
    //       type: toast.TYPE.ERROR,
    //       isLoading: false,
    //       position: toast.POSITION.BOTTOM_RIGHT,
    //       autoClose: 4000,
    //     });
    //     return;
    //   }
    // }

    meta?.addRow(newRow);
  };

  const filterOptions = () => {
    const metaType = meta?.type;
    const availableIds =
      table
        .getRowModel()
        ?.rows?.map(
          (r) => r.original?.id || r.original?.value || r.original?.substance_id
        ) || [];

    if (["analysis", "newAnalysisProtocol"].includes(metaType)) {
      const currentData =
        table.getRowModel()?.rows?.map((d) => d.original) || [];

      const availableData = [
        ...new Set(
          currentData?.flatMap((item) =>
            item?.items?.map((i) =>
              metaType === "analysis" ? i?.substance_id || i?.id : i?.name
            )
          )
        ),
      ];
      
      return meta
        ?.getAdditional()
        ?.filter(
          (f) =>
            !availableData.includes(
              metaType === "analysis" ? f?.value : f?.substance_name
            )
        )
        ?.map((o) => {
          return { ...o, name: o?.label, value: o?.items?.[0]?.id };
        });
    }
    const seen = new Set();

    return meta?.getAdditional()?.flatMap((groupOrItem) => {
      // Case 1: Grouped options (with nested `options` array)
      if (groupOrItem.is_grouped && Array.isArray(groupOrItem.options)) {
        return {
          ...groupOrItem,
          // Remove options already selected (present in availableIds)
          options: groupOrItem.options
            .filter((opt) => !availableIds.includes(opt.value))
        };
      }

      // Case 2: Flat option (non-grouped), filter + normalize
      if (!availableIds.includes(groupOrItem.value)) {
        // De-duplicate by value if we're in 'newTreatmentProtocol' mode
        if (metaType === "newTreatmentProtocol") {
          if (seen.has(groupOrItem.value)) return [];
          seen.add(groupOrItem.value);
        }

        // Normalize and return item with `name` field
        return {
          ...groupOrItem,
          name: groupOrItem.label
        };
      }

      // Skip anything not matching the above
      return [];
    });
  };

  const getTotalCost = () => {
    const costs =
      table
        .getRowModel()
        ?.rows?.map((r) => r.original)
        ?.filter((c) => c !== null && c !== undefined) || null;
    const totalCost =
      costs?.reduce((acc, curr) => {
        return (
          acc +
          (Number(curr?.total_quantity) * Number(curr?.drug_batch_cost) || 0)
        );
      }, 0) || 0;

    if (totalCost === 0) return "- €";
    return `${parseFloat(totalCost).toFixed(2)} €`;
  };

  if (type === "analysisForm") return;
  else if (type === "treatmentRecap")
    return (
      <div className="footer-buttons">
        <p>
          <span className="total-cost">{getLabel("drugTotalCost")}</span>
          <span>{getTotalCost()}</span>
        </p>
      </div>
    );
  else if (type === "treatmentRecap" || type === "treatmentRecapUser")
    return (
      <div className="footer-buttons">
        <p>
          <span className="update-drug-batches">
            {getLabel("drugChangeBatch")}
          </span>
        </p>
      </div>
    );

  return (
    <div className="footer-buttons">
      {selectedRows.length > 0 ? (
        <button className="remove-button" onClick={removeRows}>
          {`${getLabel("removeRow")} x`}
        </button>
      ) : null}
      {["newTreatmentProtocol", "newAnalysisProtocol"].includes(meta?.type) && filterOptions()?.length > 0 && (() => {
        // MultipleSelect or Select based on options
        const options = filterOptions();
        const isGrouped = options?.[0]?.is_grouped;

        const commonProps = {
          placeholder: getLabel("addNewRow"),
          isLabel: false,
          name: "dummy",
          control: meta?.getControl() ,
          options,
          onTableChange: onChange,
        };

        return isGrouped ? (
          <MultipleSelect {...commonProps} isMulti={false} />
        ) : (
          <Select {...commonProps} isTable={true} />
        );
      })()}
      {["newAnalysisProtocol"].includes(meta?.type) &&
        filterOptions()?.length === 0 && (
          <p className="remove-button">{getLabel("addNewRowUnavailable")}</p>
        )}
      {["winemaking", "caps", "bottles", "treatments", "machineries", "filters"].includes(meta?.type) && (
        <button
          className="add-button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            meta.modalHandler();
          }}
        >
          {getLabel("addNewRow")}
        </button>
      )}
    </div>
  );
};

export default FooterCell;
